import React from "react";
import moment from "moment";
import { connect } from "react-redux";

class BillPaymentModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			valList: []
		}
	}


	componentDidMount() {
		
		const map = new Map(Object.entries(this.props.rowSelected.optional));
		var valList = [];
		var mapKeys = [...map.keys()];
		if (mapKeys != undefined &&
			mapKeys.length > 0) {
			mapKeys.map(key => {
				var val = key + ":" + map.get(key);
				valList.push(val);

			})
		}

		this.setState({
			valList: valList
		})


	}
	componentWillUnmount() {
	}

	printdiv = (event) => {
        event.preventDefault();
        var divContents = document.getElementById("body").innerHTML;
        var a = window.open('', '', 'height=1000, width=1000');
        a.document.write('<html>');
        a.document.write('<body>');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }
	render() {
		
		return (
			<div class="modal fade" id="print" data-bs-backdrop="static"
				data-bs-keyboard="false" tabindex="-1">
				<div class="modal-dialog">
					<div class="modal-content">
						<div class="modal-header modhead">
							<h5 class="modal-title">Print - {this.props.rowSelected.billerCategory} Bill Payment</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body" id="body">
							<div class="printtable">
								<div class="printlogo">
									<img src="images/finxpay.png" alt="FinXpay" class="float-start" />
									<img src="images/bbps-logo.png" alt="BBPS" class="float-end" />
								</div>
								<table class="table table-striped table-bordered">
									{/* <thead>
										<tr>
											<td>Payment Status:</td>
											<td class="text-success"><strong>{
												this.props.rowSelected.lastKnownStatus
													.split('_')
													.join(' ')}</strong></td>
										</tr>
										{this.state.valList!=undefined &&
										this.state.valList.length > 0 &&
											this.state.valList.map(val => (
												<tr>
													<td>{val.split(":")[0].split("_").join(" ")}:</td>
													<td>{val.split(":")[1]}</td>
												</tr>
											))}

										<tr>
											<td>Bill Date:</td>
											<td>{this.props.rowSelected.lastBillFetch.billDate}</td>
										</tr>
										<tr>
											<td>Payment Date:</td>
											<td>{moment(this.props.rowSelected.createdOn).format('DD-MM-YYYY HH:mm:ss')}</td>
										</tr>
										<tr>
											<td>Amount:</td>
											<td>₹ {this.props.rowSelected.currentBillPayAmount}</td>
										</tr>
										<tr>
											<td>Payer Mobile No.:</td>
											<td>{this.props.rowSelected.mobileNo}</td>
										</tr>
										<tr>
											<td>State:</td>
											<td>{this.props.rowSelected.state}</td>
										</tr>
										<tr>
											<td>Provider:</td>
											<td>{this.props.rowSelected.billerName}</td>
										</tr>
										<tr>
											<td>BBPS Biller ID:</td>
											<td>NA</td>
										</tr>
										<tr>
											<td>Reference No.:</td>
											<td>{this.props.rowSelected.orderId}</td>
										</tr>
									</thead> */}
								</table>

								<p>Thank you for your payment your payment will be updated at the biller's end with 2-3 days.</p>
							</div>
						</div>
						<div class="modal-footer mdftr">
							{/* <button type="button" class="btn dbbtn" data-bs-dismiss="modal"
							onClick={this.printdiv}>Print</button> */}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage },
		miscReduce: { phone, rowSelected } }
) => ({
	errorMessage, phone, rowSelected
});

export default connect(mapStateToProps, null)(BillPaymentModal);
